<template>
  <span class="select-component">
    <select id="model" name="model" v-model="selectedModel" data-cf-modelselect @change="selectModel">
      <option value="">{{ label }}</option>
      <option v-for="(model) in models" :name="model" :key="model" :data-label="model" :value="model">{{ model }}</option>
    </select>
  </span>
</template>

<script>
export default {
  name: "Model",
  props: {
    msg: {
      type: Array
    },
    payload: {
      type: Object
    },
    label: {
      type: String
    },
    preselect: {
      type: String
    }
  },
  data() {
    return {
      models: this.msg,
      selectedModel: (this.payload.model ? this.payload.model : '')
    }
  },
  mounted() {
    console.log(this.models);
    if (this.models.length) {
      // const choicesModel = new Choices('[data-cf-modelselect]', {editItems: true});
    }
  },
  methods: {
    selectModel() {

    }
  },
  watch: {
    msg: function () {
      this.models = this.msg;
    }
  }
}
</script>

<style scoped>

</style>